<template>
  <div class="area" @click="clickEvent" :class="{ thick: isThick }">
    <div class="bar"></div>
    <div class="bar"></div>
  </div>
</template>

<script>
export default {
  methods: {
    clickEvent() {
      this.$emit('handleClick');
    },
  },

  props: {
    isThick: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
.area {
  cursor: pointer;
  .bar {
    background-color: #6f6f6f;
    width: 25px;
    height: 3px;
    &:nth-child(1) {
      transform: rotate(45deg);
    }
    &:nth-child(2) {
      transform: rotate(-45deg);
      margin-top: -3px;
    }
  }
  &.thick {
    .bar {
      height: 3px;
      &:nth-child(2) {
        margin-top: -3px;
      }
    }
  }
}
</style>
